module.exports = __webpack_public_path__ + "static/media/conflicts-screen.ca3d6dbb.png";